const API_BASE_URL = 'https://jrgfnay5w2.execute-api.ap-southeast-2.amazonaws.com/v1';

export const fetchAllTimetables = async () => {
  const response = await fetch(`${API_BASE_URL}/timetable-public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ operation: 'listAll' })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Failed to fetch timetables');
  return result.timetables; // { campusName: [url1, url2, ...], ... }
};
